export const NAMESPACE = 'API_KEYS/';
export const FETCH = `${NAMESPACE}FETCH`;
export const SET_PARAMS = `${NAMESPACE}SET_PARAMS`;
export const RESET = `${NAMESPACE}RESET`;
